export default "__VITE_ASSET__CtD06RE6__"